/**
 * The Symagic Server Service entity.
 * @author Tom Verschoore de la Houssaije
 */
import { BreezeService } from '../../core/breeze.service';
/**
 * The Symagic Server Service entity.
 */
var Service = /** @class */ (function () {
    function Service() {
        /**
         * Holding Reference of shift
         * @private
         * @type {Entity}
         */
        this.shift = undefined;
    }
    Object.defineProperty(Service.prototype, "StartBase", {
        /**
         * Gets the StartBase of the Service.
         * @type {Date}
         */
        get: function () {
            return this.startBase;
        },
        /**
         * Sets the StartBase of the Service.
         * @type {Date}
         */
        set: function (value) {
            this.startBase = value;
            if (this.entityAspect.entityState.isAdded()) {
                this.Start = value; // Fix: Waarden Start en Eind voor een service(template) niet goed bij voor het eerst opslaan #2787
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Service.prototype, "FinishBase", {
        /**
         * Gets the FinishBase of the Service.
         * @type {Date}
         */
        get: function () {
            return this.finishBase;
        },
        /**
         * Sets the FinishBase of the Service.
         * @type {Date}
         */
        set: function (value) {
            this.finishBase = value;
            if (this.entityAspect.entityState.isAdded()) {
                this.Finish = value; // Fix: Waarden Start en Eind voor een service(template) niet goed bij voor het eerst opslaan #2787
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Service.prototype, "Shift", {
        /**
         * Gets the shift of the service.
         * @readonly
         * @type {Entity}
         */
        get: function () {
            // This is needed to override breeze.js navigation property.
            if (!this.shift && this.entityAspect && this.entityAspect.entityState.isDetached()) {
                return undefined;
            }
            return this.shift;
        },
        /**
         * Sets the shift of the service
         */
        set: function (value) {
            if (value && value !== this.shift && this.entityAspect.entityState.isAdded()) {
                this.Start = value['Start'];
                this.Finish = value['Finish'];
                this.StartBase = value['Start'];
                this.FinishBase = value['Finish'];
                this.Name = value['Name'];
                this.Color = value['Color'];
                this['SumFactor'] = value['SumFactor'];
            }
            this.shift = value;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Removes Taskneed instance from this object with taking into account situations of inherited collections.
     * @param {string} taskNeed The Oid of the Taskneed to remove.
     * @param {boolean} [afterSave=false] Indicates whether the method is invoked after properties changes are committed or before
     * @memberOf Service
     */
    Service.prototype.removeNeed = function (taskNeed, afterSave) {
        if (afterSave === void 0) { afterSave = false; }
        return BreezeService.invokeMethod(this, 'RemoveNeed', [taskNeed], afterSave);
    };
    return Service;
}());
export { Service };
